module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWBAMAAAA2mnEIAAAAKlBMVEUAAAATtvYQr+8UtfUUtfUQt/cUtvYUtvYUs/MUtvYTt/cVtfYTtfQUtvajeKbaAAAADXRSTlMA3xDvgCDPr0C/n29gojmB2gAAAJtJREFUGNNjAIKYQmPxTQxgwCJ79+7dy04gJmvuXRC4FgBkB96FAFEGBiagMEQCqPouDDgwKAPJFUqdYEV77969AtTle/fuHYbau3cnANlcd+9eZwAa3gBkc9y9e5HB9u5dBSCbCWgdMhtZDUjvAiCbE6T3LNzM22DnzFDqApJGKG5ggLtNAcnNaH5hULEFMi86QDysDfT7USANAB+qetuidYf4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./images/baseintrov2/main-o.png
// module id = 591
// module chunks = 0